import React, { useState } from 'react';
import { BASE_URL } from '../../config';
import { getToken } from '../../api';

export default function DownloadPDFButton({ voucherId, voucherNo, toast }) {
  const [busy, setBusy] = useState(false);

  const handleDownload = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    try {
      const res = await fetch(`${BASE_URL}/payment-vouchers/${voucherId}/pdf`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || `Server error ${res.status}`);
      }
      const blob = await res.blob();
      const filename = voucherNo
        ? `${voucherNo.replace(/\//g, '-')}.pdf`
        : `voucher-${voucherId}.pdf`;
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      toast?.show('PDF download failed: ' + err.message, 'error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleDownload}
      title="Download PDF"
      aria-label="Download PDF"
      disabled={busy}
      style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: 30, height: 30, borderRadius: 8,
        cursor: busy ? 'wait' : 'pointer',
        background: 'var(--bg-card)',
        border: '1px solid #dc2626',
        color: '#dc2626',
        transition: 'background 0.15s, color 0.15s',
        opacity: busy ? 0.6 : 1,
      }}
      onMouseEnter={(e) => {
        if (!busy) {
          e.currentTarget.style.background = '#dc2626';
          e.currentTarget.style.color = '#fff';
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.background = 'var(--bg-card)';
        e.currentTarget.style.color = '#dc2626';
      }}
    >
      {busy ? (
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
          <circle cx="12" cy="12" r="10" strokeDasharray="40" strokeDashoffset="15"
            style={{ animation: 'spin 0.8s linear infinite', transformOrigin: 'center' }} />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="12" y1="18" x2="12" y2="12" />
          <polyline points="9 15 12 18 15 15" />
        </svg>
      )}
    </button>
  );
}
